import React, { useState, useEffect } from 'react';
import "../../pages/SemanaVolteon.css"

const Dinamicas = () => {
    return (
        <div className="semana-container">
            <div className="dinamica">
                <h1>Preparate para todas las dinámicas que Volteon te trae</h1>
                <div className="productos-row">
                    <div className="dinamica">
                        <img src={'/images/Descuento.png'} alt="Descuento sorpresa" className="dinamica-image"/>
                        <p className="dinamica-desc">Cada día de la semana habrá productos diferentes en descuento que no te podés perder</p>
                    </div>
                    <div className="dinamica">
                        <img src={'/images/Raspa.png'} alt="Raspa y gana" className="dinamica-image"/>
                        <p className="dinamica-desc">Por cada ₡5000 de compra te llevás una Raspa Volteon que puede contener una amplia variedad de premios: desde descuentos en artículos hasta placas de microcontrolador</p>
                    </div>
                </div>
            </div>
        </div>


    );
};

export default Dinamicas;